import type { Editor } from "@tiptap/core";

/**
 * Collect the IDs of all inlineExpression nodes before `pos` in the Tiptap document.
 *
 * Two scope rules keep unrelated definitions out:
 * - A `horizontalRule` acts as a scope boundary.
 * - A table's expressions are in scope inside that same table only, so every table that does not
 *   hold `pos` is skipped.
 */
export function collectPrecedingWrapperIds(tiptap: Editor, pos: number): string[] {
  if (pos <= 0) return [];

  let seen = new Set<string>();
  let wrapperNodeIds: string[] = [];
  tiptap.state.doc.nodesBetween(0, pos - 1, (node, nodePos) => {
    if (node.type.name === "horizontalRule") {
      seen = new Set<string>();
      wrapperNodeIds = [];
      return undefined;
    }

    if (node.type.name === "table" && !(pos > nodePos && pos < nodePos + node.nodeSize)) {
      return false;
    }

    if (node.type.name === "inlineExpression") {
      const nodeId = node.attrs.nodeId as string;
      if (nodeId && !seen.has(nodeId)) {
        seen.add(nodeId);
        wrapperNodeIds.push(nodeId);
      }
    }
    return undefined;
  });
  return wrapperNodeIds;
}
